// extracted by mini-css-extract-plugin
module.exports = {"root":"DropZone_root__1T4-j","placeholder":"DropZone_placeholder__bA2fL","fileRoot":"DropZone_fileRoot__ZaKrZ","close":"DropZone_close__vGKHI"};